import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";

import { DialogCancelConfirmation } from "../../../../components/Dialogs/DialogCancelConfirmation";

/**
 * Modale d'export Excel : choix de la période, bornée à l'année affichée (le back refuse deux années différentes)
 * @param {{ open: boolean, year: number, isExporting: boolean, onClose: function, onExport: function }} props
 */
const ExportSummaryDialog = ({ open, year, isExporting, onClose, onExport }) => {
    const minDate = `${year}-01-01`;
    const maxDate = `${year}-12-31`;
    const [startDate, setStartDate] = useState(minDate);
    const [endDate, setEndDate] = useState(maxDate);

    useEffect(() => {
        if (!open) return;
        setStartDate(minDate);
        setEndDate(maxDate);
    }, [open, minDate, maxDate]);

    const isValid = startDate && endDate && startDate <= endDate;

    return (
        <DialogCancelConfirmation
            open={open}
            width="520"
            header="Exporter le suivi du temps"
            cancelButton="Annuler"
            confirmButton={{
                content: "Exporter",
                disabled: !isValid || isExporting,
                loading: isExporting,
            }}
            onClose={onClose}
            onConfirm={() =>
                onExport({ start_date: startDate, end_date: endDate })
            }
            content={
                <Period>
                    <PeriodTitle>Période</PeriodTitle>
                    <Dates>
                        <DateField>
                            Début
                            <DateInput
                                type="date"
                                value={startDate}
                                min={minDate}
                                max={endDate || maxDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </DateField>
                        <Arrow>→</Arrow>
                        <DateField>
                            Fin
                            <DateInput
                                type="date"
                                value={endDate}
                                min={startDate || minDate}
                                max={maxDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </DateField>
                    </Dates>
                </Period>
            }
        />
    );
};

export default ExportSummaryDialog;

const Period = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const PeriodTitle = styled.span`
    font-size: 13px;
    font-weight: 600;
`;

const Dates = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
`;

const DateField = styled.label`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    color: #616161;
    flex: 1 1 180px;
`;

const DateInput = styled.input`
    font: inherit;
    font-size: 14px;
    color: #212121;
    height: 34px;
    padding: 0 10px;
    border: 1px solid #d1d1d1;
    border-bottom: 2px solid #5b5fc7;
    border-radius: 4px;
    background: #fff;
`;

const Arrow = styled.span`
    height: 34px;
    display: flex;
    align-items: center;
    color: #616161;
`;
